import { closestCenter, DndContext, type DragEndEvent, type UniqueIdentifier } from '@dnd-kit/core'
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable'
import { QuestionRow } from '../question-row'
import { useSortableList } from '../use-sortable-list'
import type { QuestionListProps } from './question-list.interface'
import classes from './question-list.module.scss'

export function QuestionList({ editor }: QuestionListProps) {
  const { questions } = editor.state
  const labelFor = (id: UniqueIdentifier) => questions.find((question) => question.key === id)?.label ?? 'question'
  const sortable = useSortableList(labelFor)
  const editingKey = editor.openCard?.mode === 'edit' ? editor.openCard.key : null

  const handleDragEnd = ({ active, over }: DragEndEvent) => {
    if (over) editor.moveQuestion(String(active.id), String(over.id))
  }

  return (
    <DndContext {...sortable} collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
      <SortableContext items={questions.map((question) => question.key)} strategy={verticalListSortingStrategy}>
        <ul className={classes.root} aria-label="Questions">
          {questions.map((question) => (
            <QuestionRow
              key={question.key}
              question={question}
              isEditing={question.key === editingKey}
              onEdit={() => editor.openEditCard(question.key)}
              onDelete={() => editor.deleteQuestion(question.key)}
              onUpdate={(draft) => editor.updateQuestion(question.key, draft)}
              onCancelEdit={editor.closeCard}
            />
          ))}
        </ul>
      </SortableContext>
    </DndContext>
  )
}
